var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { currentDateKey, dateToKey, dateToSpecifiedFormat, keyToDate, parseAndValidateDate, } from './date-picker-calculations';
import '../shared/month-view/month-view.lit';
import '../shared/calendar/sds-calendar.lit';
import styles from './sds-date-entry-input.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { classMap } from 'lit/directives/class-map.js';
import { formatDateValue, getFieldOrder, getLocaleFormatInfo } from './utils/locale.lit';
/**
 * `sds-date-entry-input` is a web component that allows users to select a date using an interactive calendar interface.
 * It provides a user-friendly way to choose a single date and offers features such as localization, placeholders,
 * and optional clear functionality.
 *
 * ### Features:
 * - **Clear button** to reset the selected date (configurable).
 * - **Locale support** to format the date according to regional settings.
 * - **Placeholder text** to guide users when no date is selected.
 * - **Responsive calendar view**, adapting to different screen sizes.
 * - Emits events on date selection for easy integration with other components or logic.
 */
let SdsDateEntryInput = (() => {
    var _SdsDateEntryInput_hint_accessor_storage, _SdsDateEntryInput_disabled_accessor_storage, _SdsDateEntryInput_invalid_accessor_storage, _SdsDateEntryInput_errorMessage_accessor_storage, _SdsDateEntryInput_locale_accessor_storage, _SdsDateEntryInput__internalValue_accessor_storage, _SdsDateEntryInput_currentDay_accessor_storage, _SdsDateEntryInput_hasClear_accessor_storage, _SdsDateEntryInput__displayMonth_accessor_storage, _SdsDateEntryInput__displayDay_accessor_storage, _SdsDateEntryInput__displayYear_accessor_storage, _SdsDateEntryInput__isMonthSelected_accessor_storage, _SdsDateEntryInput__isDaySelected_accessor_storage, _SdsDateEntryInput__isYearSelected_accessor_storage, _SdsDateEntryInput__isYearTyping_accessor_storage, _SdsDateEntryInput__buttonFocused_accessor_storage, _SdsDateEntryInput__isFieldFocused_accessor_storage, _SdsDateEntryInput__isUserInput_accessor_storage, _SdsDateEntryInput__isClearing_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-date-entry-input')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let __internalValue_decorators;
    let __internalValue_initializers = [];
    let __internalValue_extraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let _hasClear_decorators;
    let _hasClear_initializers = [];
    let _hasClear_extraInitializers = [];
    let __displayMonth_decorators;
    let __displayMonth_initializers = [];
    let __displayMonth_extraInitializers = [];
    let __displayDay_decorators;
    let __displayDay_initializers = [];
    let __displayDay_extraInitializers = [];
    let __displayYear_decorators;
    let __displayYear_initializers = [];
    let __displayYear_extraInitializers = [];
    let __isMonthSelected_decorators;
    let __isMonthSelected_initializers = [];
    let __isMonthSelected_extraInitializers = [];
    let __isDaySelected_decorators;
    let __isDaySelected_initializers = [];
    let __isDaySelected_extraInitializers = [];
    let __isYearSelected_decorators;
    let __isYearSelected_initializers = [];
    let __isYearSelected_extraInitializers = [];
    let __isYearTyping_decorators;
    let __isYearTyping_initializers = [];
    let __isYearTyping_extraInitializers = [];
    let __buttonFocused_decorators;
    let __buttonFocused_initializers = [];
    let __buttonFocused_extraInitializers = [];
    let __isFieldFocused_decorators;
    let __isFieldFocused_initializers = [];
    let __isFieldFocused_extraInitializers = [];
    let __isUserInput_decorators;
    let __isUserInput_initializers = [];
    let __isUserInput_extraInitializers = [];
    let __isClearing_decorators;
    let __isClearing_initializers = [];
    let __isClearing_extraInitializers = [];
    var SdsDateEntryInput = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDateEntryInput_hint_accessor_storage.set(this, __runInitializers(this, _hint_initializers, ''));
            _SdsDateEntryInput_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsDateEntryInput_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsDateEntryInput_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsDateEntryInput_locale_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _locale_initializers, navigator.language)));
            _SdsDateEntryInput__internalValue_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, __internalValue_initializers, void 0)));
            _SdsDateEntryInput_currentDay_accessor_storage.set(this, (__runInitializers(this, __internalValue_extraInitializers), __runInitializers(this, _currentDay_initializers, currentDateKey())));
            _SdsDateEntryInput_hasClear_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, _hasClear_initializers, true)));
            _SdsDateEntryInput__displayMonth_accessor_storage.set(this, (__runInitializers(this, _hasClear_extraInitializers), __runInitializers(this, __displayMonth_initializers, formatDateValue(null, 'month', this.locale))));
            _SdsDateEntryInput__displayDay_accessor_storage.set(this, (__runInitializers(this, __displayMonth_extraInitializers), __runInitializers(this, __displayDay_initializers, formatDateValue(null, 'day', this.locale))));
            _SdsDateEntryInput__displayYear_accessor_storage.set(this, (__runInitializers(this, __displayDay_extraInitializers), __runInitializers(this, __displayYear_initializers, formatDateValue(null, 'year', this.locale))));
            _SdsDateEntryInput__isMonthSelected_accessor_storage.set(this, (__runInitializers(this, __displayYear_extraInitializers), __runInitializers(this, __isMonthSelected_initializers, false)));
            _SdsDateEntryInput__isDaySelected_accessor_storage.set(this, (__runInitializers(this, __isMonthSelected_extraInitializers), __runInitializers(this, __isDaySelected_initializers, false)));
            _SdsDateEntryInput__isYearSelected_accessor_storage.set(this, (__runInitializers(this, __isDaySelected_extraInitializers), __runInitializers(this, __isYearSelected_initializers, false)));
            _SdsDateEntryInput__isYearTyping_accessor_storage.set(this, (__runInitializers(this, __isYearSelected_extraInitializers), __runInitializers(this, __isYearTyping_initializers, false)));
            _SdsDateEntryInput__buttonFocused_accessor_storage.set(this, (__runInitializers(this, __isYearTyping_extraInitializers), __runInitializers(this, __buttonFocused_initializers, false)));
            _SdsDateEntryInput__isFieldFocused_accessor_storage.set(this, (__runInitializers(this, __buttonFocused_extraInitializers), __runInitializers(this, __isFieldFocused_initializers, false)));
            _SdsDateEntryInput__isUserInput_accessor_storage.set(this, (__runInitializers(this, __isFieldFocused_extraInitializers), __runInitializers(this, __isUserInput_initializers, false)));
            _SdsDateEntryInput__isClearing_accessor_storage.set(this, (__runInitializers(this, __isUserInput_extraInitializers), __runInitializers(this, __isClearing_initializers, false)));
            this._firstDayDigit = (__runInitializers(this, __isClearing_extraInitializers), null);
            this._awaitingSecondMonthDigit = false;
            this._awaitingSecondDayDigit = false;
            this.handleFieldFocus = (e) => {
                var _a, _b, _c;
                // Don't handle focus when disabled
                if (this.disabled) {
                    // Blur the element immediately to prevent focus
                    (_a = e.target) === null || _a === void 0 ? void 0 : _a.blur();
                    return;
                }
                const target = e.target;
                const inputs = Array.from(((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.sds-date-entry-input__field')) || []);
                const index = inputs.indexOf(target);
                // Only proceed if this is a valid input field
                if (index === -1) {
                    return;
                }
                // Check if the target is already selected
                const isAlreadySelected = target.classList.contains('sds-date-entry-input__field--selected');
                // Only remove and re-add classes if not already selected
                if (!isAlreadySelected) {
                    // Remove selected class from all inputs
                    inputs.forEach(input => input.classList.remove('sds-date-entry-input__field--selected'));
                    // Add selected class to the focused field
                    target.classList.add('sds-date-entry-input__field--selected');
                }
                // Only set field focused if not already focused
                if (!this._isFieldFocused) {
                    this._isFieldFocused = true;
                }
                // Update selection states
                const fieldOrder = getFieldOrder(this.locale);
                const fieldType = fieldOrder[index];
                this._isMonthSelected = fieldType === 'month';
                this._isDaySelected = fieldType === 'day';
                this._isYearSelected = fieldType === 'year';
                // Dispatch focus event only when coming from action button (regaining focus)
                const relatedTarget = e.relatedTarget;
                const isComingFromActionButton = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.closest('.sds-date-entry-input__actions');
                if (isComingFromActionButton) {
                    const container = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.sds-date-entry-input');
                    this.dispatchEvent(new CustomEvent('focus', {
                        bubbles: true,
                        composed: true,
                        detail: {
                            target: container,
                            relatedTarget: e.relatedTarget,
                        },
                    }));
                }
            };
            this.handleFieldBlur = (event) => {
                var _a, _b, _c;
                // Don't handle blur when disabled
                if (this.disabled) {
                    return;
                }
                // Check if focus is moving to another field within the component
                const relatedTarget = event === null || event === void 0 ? void 0 : event.relatedTarget;
                const isMovingToField = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.classList.contains('sds-date-entry-input__field');
                // If moving to another field, don't clean up yet
                if (isMovingToField) {
                    return;
                }
                // Check if moving to the container (this is not a real blur, just internal focus change)
                const isMovingToContainer = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.classList.contains('sds-date-entry-input__container');
                if (isMovingToContainer) {
                    return;
                }
                // Check if moving to action button (clear button or calendar button)
                const isMovingToActionButton = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.closest('.sds-date-entry-input__actions');
                // If moving to action buttons, don't clean up the field focused state to prevent blinking
                if (isMovingToActionButton) {
                    // Remove selected classes but keep _isFieldFocused = true
                    const inputs = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
                    inputs === null || inputs === void 0 ? void 0 : inputs.forEach(input => {
                        input.classList.remove('sds-date-entry-input__field--selected');
                    });
                    const container = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.sds-date-entry-input');
                    this.dispatchEvent(new CustomEvent('blur', {
                        bubbles: true,
                        composed: true,
                        detail: {
                            target: container,
                            relatedTarget: event === null || event === void 0 ? void 0 : event.relatedTarget,
                        },
                    }));
                }
                else {
                    // Focus is leaving the component entirely - clean up everything
                    const inputs = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll('.sds-date-entry-input__field');
                    inputs === null || inputs === void 0 ? void 0 : inputs.forEach(input => {
                        input.classList.remove('sds-date-entry-input__field--selected');
                    });
                    this._isFieldFocused = false;
                }
            };
            this.handleInputTextClick = (event) => {
                var _a, _b;
                // Don't handle clicks when disabled
                if (this.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                // Only handle clicks directly on the input field
                if (event.target !== event.currentTarget) {
                    return;
                }
                event.stopPropagation();
                // Dispatch click event for consistency
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                    view: window,
                });
                this.dispatchEvent(clickEvent);
                const target = event.target;
                // Check if the clicked target is already selected
                const isAlreadySelected = target.classList.contains('sds-date-entry-input__field--selected');
                // Only remove and re-add classes if not already selected
                if (!isAlreadySelected) {
                    const inputTexts = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
                    inputTexts === null || inputTexts === void 0 ? void 0 : inputTexts.forEach(input => {
                        input.classList.remove('sds-date-entry-input__field--selected');
                    });
                    target.classList.add('sds-date-entry-input__field--selected');
                }
                target.focus();
                this._isFieldFocused = true;
                this.resetTypingStates();
                // Set the appropriate selection state based on the position of the clicked element
                const inputs = Array.from(((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.sds-date-entry-input__field')) || []);
                const clickedIndex = inputs.indexOf(target);
                const fieldOrder = getFieldOrder(this.locale);
                const selectedType = fieldOrder[clickedIndex];
                this._isMonthSelected = selectedType === 'month';
                this._isDaySelected = selectedType === 'day';
                this._isYearSelected = selectedType === 'year';
            };
            this.handleInputContainerClick = (event) => {
                var _a, _b;
                // Don't handle clicks when disabled
                if (this.disabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                // Only handle clicks on the container itself or separators, not on fields
                const target = event.target;
                if (target &&
                    target.classList &&
                    target.classList.contains('sds-date-entry-input__field')) {
                    return; // Let the field handle its own click
                }
                // First dispatch the click event
                event.stopPropagation();
                // Dispatch click event
                const clickEvent = new MouseEvent('click', {
                    bubbles: true,
                    composed: true,
                    cancelable: true,
                    view: window,
                });
                this.dispatchEvent(clickEvent);
                // Then handle focus
                const selectedElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-date-entry-input__field--selected');
                if (selectedElement) {
                    selectedElement.focus();
                    return;
                }
                const inputs = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.sds-date-entry-input__field');
                if (!inputs) {
                    return;
                }
                // Check the state of each field
                const isMonthEmpty = this._displayMonth === 'mm';
                const isDayEmpty = this._displayDay === 'dd';
                const isYearEmpty = this._displayYear === 'yyyy';
                this.resetTypingStates();
                const fieldOrder = getFieldOrder(this.locale);
                let targetIndex = 0;
                // If all fields are empty, select first field
                if (isMonthEmpty && isDayEmpty && isYearEmpty) {
                    targetIndex = 0;
                }
                // If all fields are filled, select last field
                else if (!isMonthEmpty && !isDayEmpty && !isYearEmpty) {
                    targetIndex = fieldOrder.length - 1;
                }
                // Otherwise, find the first empty field
                else {
                    for (let i = 0; i < fieldOrder.length; i++) {
                        const type = fieldOrder[i];
                        if ((type === 'month' && isMonthEmpty) ||
                            (type === 'day' && isDayEmpty) ||
                            (type === 'year' && isYearEmpty)) {
                            targetIndex = i;
                            break;
                        }
                    }
                }
                this.moveFocusToField(targetIndex);
            };
            this.handleDocumentClick = (event) => {
                var _a, _b;
                const target = event.target;
                const datePicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-date-entry-input');
                // Only handle clicks that are truly outside our component
                if (datePicker && !datePicker.contains(target)) {
                    const inputTexts = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.sds-date-entry-input__field');
                    inputTexts === null || inputTexts === void 0 ? void 0 : inputTexts.forEach(input => {
                        input.classList.remove('sds-date-entry-input__field--selected');
                        input.blur();
                    });
                    this._isFieldFocused = false;
                    this.resetTypingStates();
                }
            };
            this.handlePaste = (event) => {
                event.preventDefault();
                event.stopPropagation();
            };
        }
        /**
         * Hint for this date picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsDateEntryInput_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_hint_accessor_storage, value, "f"); }
        /**
         * True if this date picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsDateEntryInput_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsDateEntryInput_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this date picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsDateEntryInput_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_errorMessage_accessor_storage, value, "f"); }
        /**
         * The locale to use for date formatting.
         * This affects how dates are displayed and formatted.
         *
         * Examples:
         * - 'en-US' (US English)
         * - 'de-DE' (German)
         * - 'fr-FR' (French)
         * - 'ja-JP' (Japanese)
         *
         * Defaults to the browser's locale (navigator.language)
         *
         * @attr
         */
        get locale() { return __classPrivateFieldGet(this, _SdsDateEntryInput_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_locale_accessor_storage, value, "f"); }
        /** Internal storage for the selected date as LocalDate array */
        get _internalValue() { return __classPrivateFieldGet(this, _SdsDateEntryInput__internalValue_accessor_storage, "f"); }
        set _internalValue(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__internalValue_accessor_storage, value, "f"); }
        /**
         * The selected date value. Supports multiple input formats:
         * - ISO string format (YYYY-MM-DD) - HTML5 standard
         * - Legacy string format (YYYY/MM/DD) - backward compatibility
         * - Any valid date string parseable by Date constructor
         * - Timestamp (number) - milliseconds or seconds since Unix epoch
         * - Date object
         *
         * Always returns ISO format string (YYYY-MM-DD) when getting the value.
         *
         * @attr {DateValue} value - Any value that new Date() can parse
         * @example
         * // String formats
         * <sds-date-entry-input value="2024-03-15"></sds-date-entry-input>
         * <sds-date-entry-input value="2024/03/15"></sds-date-entry-input>
         * <sds-date-entry-input value="March 15, 2024"></sds-date-entry-input>
         * <sds-date-entry-input value="Mon Sep 08 2025 14:32:42 GMT+0400"></sds-date-entry-input>
         *
         * // Timestamp
         * <sds-date-entry-input value="1710460800000"></sds-date-entry-input>
         *
         * // Programmatic usage
         * datePicker.value = new Date();
         * datePicker.value = 1710460800000;
         * datePicker.value = "March 15, 2024";
         */
        get value() {
            if (!this._internalValue)
                return undefined;
            const [year, month, day] = this._internalValue;
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        set value(val) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (val === undefined || val === null) {
                this._internalValue = undefined;
            }
            else {
                this._internalValue = parseAndValidateDate(val);
            }
        }
        /**
         * Internal getter for backward compatibility - returns the LocalDate array format
         */
        get valueAsLocalDate() {
            return this._internalValue;
        }
        /**
         * Gets/sets the selected date as a Date object (HTML5 input[type="date"] compatible).
         * @example
         * datePicker.valueAsDate = new Date('2024-03-15');
         * console.log(datePicker.valueAsDate); // Date object
         */
        get valueAsDate() {
            if (!this._internalValue)
                return null;
            const [year, month, day] = this._internalValue;
            // Use setFullYear to avoid JavaScript's 0-99 year interpretation
            const date = new Date();
            date.setFullYear(year, month - 1, day);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        set valueAsDate(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (value === null) {
                this._internalValue = undefined;
            }
            else {
                const year = value.getFullYear();
                const month = value.getMonth() + 1;
                const day = value.getDate();
                this._internalValue = [year, month, day];
            }
        }
        /**
         * Gets/sets the selected date as milliseconds since Unix epoch (HTML5 input[type="date"] compatible).
         * @example
         * datePicker.valueAsNumber = Date.parse('2024-03-15');
         * console.log(datePicker.valueAsNumber); // 1710460800000
         */
        get valueAsNumber() {
            const date = this.valueAsDate;
            return date ? date.getTime() : NaN;
        }
        set valueAsNumber(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (isNaN(value)) {
                this.valueAsDate = null;
            }
            else {
                this.valueAsDate = new Date(value);
            }
        }
        get currentDay() { return __classPrivateFieldGet(this, _SdsDateEntryInput_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_currentDay_accessor_storage, value, "f"); }
        /**
         * Controls whether the date picker displays a "clear" button, allowing users to remove the selected date.
         * When enabled, the clear button provides an easy way to reset the input field to an empty state.
         *
         * - If `true`, the clear button is visible within the picker.
         * - If `false`, the clear button is hidden, preventing users from clearing the date input.
         *
         * Defaults to `true`.
         *
         * @attr {boolean} has-clear - Whether the picker shows a clear button.
         */
        get hasClear() { return __classPrivateFieldGet(this, _SdsDateEntryInput_hasClear_accessor_storage, "f"); }
        set hasClear(value) { __classPrivateFieldSet(this, _SdsDateEntryInput_hasClear_accessor_storage, value, "f"); }
        get _displayMonth() { return __classPrivateFieldGet(this, _SdsDateEntryInput__displayMonth_accessor_storage, "f"); }
        set _displayMonth(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__displayMonth_accessor_storage, value, "f"); }
        get _displayDay() { return __classPrivateFieldGet(this, _SdsDateEntryInput__displayDay_accessor_storage, "f"); }
        set _displayDay(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__displayDay_accessor_storage, value, "f"); }
        get _displayYear() { return __classPrivateFieldGet(this, _SdsDateEntryInput__displayYear_accessor_storage, "f"); }
        set _displayYear(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__displayYear_accessor_storage, value, "f"); }
        get _isMonthSelected() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isMonthSelected_accessor_storage, "f"); }
        set _isMonthSelected(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isMonthSelected_accessor_storage, value, "f"); }
        get _isDaySelected() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isDaySelected_accessor_storage, "f"); }
        set _isDaySelected(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isDaySelected_accessor_storage, value, "f"); }
        get _isYearSelected() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isYearSelected_accessor_storage, "f"); }
        set _isYearSelected(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isYearSelected_accessor_storage, value, "f"); }
        get _isYearTyping() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isYearTyping_accessor_storage, "f"); }
        set _isYearTyping(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isYearTyping_accessor_storage, value, "f"); }
        get _buttonFocused() { return __classPrivateFieldGet(this, _SdsDateEntryInput__buttonFocused_accessor_storage, "f"); }
        set _buttonFocused(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__buttonFocused_accessor_storage, value, "f"); }
        get _isFieldFocused() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isFieldFocused_accessor_storage, "f"); }
        set _isFieldFocused(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isFieldFocused_accessor_storage, value, "f"); }
        get _isUserInput() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isUserInput_accessor_storage, "f"); }
        set _isUserInput(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isUserInput_accessor_storage, value, "f"); }
        get _isClearing() { return __classPrivateFieldGet(this, _SdsDateEntryInput__isClearing_accessor_storage, "f"); }
        set _isClearing(value) { __classPrivateFieldSet(this, _SdsDateEntryInput__isClearing_accessor_storage, value, "f"); }
        getClasses() {
            return classMap({
                'sds-date-entry-input': true,
                'sds-date-entry-input--focused': this._isFieldFocused,
                'sds-date-entry-input--invalid': this.invalid,
                'sds-date-entry-input--disabled': this.disabled,
            });
        }
        render() {
            const formatInfo = getLocaleFormatInfo(this.locale);
            return html `
            <div class="${this.getClasses()}">
                <input
                    type="hidden"
                    name="date"
                    value="${this._internalValue
                ? dateToSpecifiedFormat(this._internalValue, 'yyyy-MM-dd')
                : ''}"
                />
                <div
                    class="sds-date-entry-input__container"
                    contenteditable="${!this.disabled}"
                    tabindex="-1"
                    @click="${this.handleInputContainerClick}"
                    @keydown="${(e) => this.handleKeyDown(e)}"
                    @paste="${(e) => this.handlePaste(e)}"
                >
                    ${formatInfo.map(part => {
                if (part.type === 'literal') {
                    // Use the actual separator from the locale
                    return html `<div class="sds-date-entry-input__separator">
                                ${part.value}
                            </div>`;
                }
                const value = part.type === 'month'
                    ? this._displayMonth
                    : part.type === 'day'
                        ? this._displayDay
                        : this._displayYear;
                return this.renderDateField(part.type, value);
            })}
                </div>
                <div class="sds-date-entry-input__actions">
                    ${this.renderClear()} ${this.renderCalendarButton()}
                </div>
            </div>
            ${this.renderMessages()}
        `;
        }
        renderMessages() {
            if (this.hint || this.invalid) {
                return html `
                <div class="sds-date-entry-input__messages">
                    ${this.renderHint()} ${this.renderError()}
                </div>
            `;
            }
        }
        renderCalendarButton() {
            return html `
            <sds-button
                type="ghost"
                size="lg"
                icon="calendar_date"
                class="sds-date-entry-input__calendar-icon"
                ?disabled="${this.disabled}"
                @focus="${(e) => this.handleActionFocus(e)}"
                @blur="${(e) => this.handleActionBlur(e)}"
                @click="${(e) => this.handleActionClick(e)}"
                style="
                    top: 4px;
                    inset-inline-end: 4px;
                "
            ></sds-button>
        `;
        }
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html ` <sds-error message="${this.errorMessage}"></sds-error> `;
            }
        }
        renderHint() {
            if (this.hint) {
                return html ` <div class="sds-date-entry-input__hint">${this.hint}</div> `;
            }
        }
        // Renders a single date field
        renderDateField(type, value) {
            return html `
            <div
                class="sds-date-entry-input__field"
                tabindex="0"
                @click="${(e) => this.handleInputTextClick(e)}"
                @focus="${(e) => this.handleFieldFocus(e)}"
                @blur="${(e) => this.handleFieldBlur(e)}"
            >
                ${value}
            </div>
        `;
        }
        renderClear() {
            if (this.showClear()) {
                return html `
                <sds-button
                    class="sds-date-entry-input__action-clear"
                    type="tertiary"
                    icon="close_circle"
                    size="md"
                    aria-label="Clear date"
                    ?disabled="${this.disabled}"
                    @focus="${(e) => this.handleActionFocus(e)}"
                    @blur="${(e) => this.handleActionBlur(e)}"
                    @click="${(e) => this.handleClear(e)}"
                ></sds-button>
            `;
            }
        }
        showClear() {
            const hasValue = this._displayMonth !== 'mm' ||
                this._displayDay !== 'dd' ||
                this._displayYear !== 'yyyy';
            return hasValue && !this.disabled && this.hasClear;
        }
        handleClear(event) {
            var _a, _b;
            // Reset all display values
            this._displayMonth = 'mm';
            this._displayDay = 'dd';
            this._displayYear = 'yyyy';
            // Reset all states
            this.resetTypingStates();
            // Remove selected class from all inputs
            const inputs = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
            inputs === null || inputs === void 0 ? void 0 : inputs.forEach(input => {
                input.classList.remove('sds-date-entry-input__field--selected');
                input.blur();
            });
            // Update hidden input without firing input event
            const hiddenInput = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('input[type="hidden"]');
            if (hiddenInput) {
                hiddenInput.value = '';
                // Only dispatch change if we previously had a valid date
                if (this._internalValue) {
                    this.dispatchChange(undefined);
                }
            }
            // Dispatch clear event
            this.dispatchEvent(new CustomEvent(SdsDateEntryInput.DATE_CLEARED, {
                detail: { selectedDate: undefined },
                bubbles: false,
                composed: false,
            }));
            // Focus the first field
            this.moveFocusToField(0);
            event === null || event === void 0 ? void 0 : event.stopPropagation();
        }
        handleActionFocus(event) {
            event.stopPropagation();
            // Check if focus is coming from an input field
            const relatedTarget = event.relatedTarget;
            const isComingFromField = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.classList.contains('sds-date-entry-input__field');
            // Only set field focus state to false if NOT coming from an input field
            // This prevents blinking when moving from input field to action button
            if (!isComingFromField) {
                this._isFieldFocused = false;
            }
            this._buttonFocused = true;
        }
        handleActionBlur(event) {
            event.stopPropagation();
            this._buttonFocused = false;
        }
        handleActionClick(event) {
            var _a;
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            this._isFieldFocused = true;
            const inputs = Array.from(((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field')) || []);
            inputs.forEach(input => input.classList.remove('sds-date-entry-input__field--selected'));
            // Dispatch calendar button click event
            this.dispatchEvent(new CustomEvent(SdsDateEntryInput.CALENDAR_BUTTON_CLICKED, {
                bubbles: true,
                composed: true,
            }));
        }
        moveFocusToField(fieldIndex) {
            var _a;
            const inputs = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
            if (!inputs || fieldIndex < 0 || fieldIndex >= inputs.length) {
                return;
            }
            // Remove selected class from all inputs
            inputs.forEach(input => input.classList.remove('sds-date-entry-input__field--selected'));
            // Add selected class to target input
            inputs[fieldIndex].classList.add('sds-date-entry-input__field--selected');
            // Update selection states based on field type
            const fieldOrder = getFieldOrder(this.locale);
            const fieldType = fieldOrder[fieldIndex];
            this._isMonthSelected = fieldType === 'month';
            this._isDaySelected = fieldType === 'day';
            this._isYearSelected = fieldType === 'year';
            // Focus the target input
            inputs[fieldIndex].focus();
            this._isFieldFocused = true;
        }
        handleFieldDeletion(field) {
            var _a, _b, _c, _d, _e;
            const inputs = Array.from(((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field')) || []);
            const currentIndex = inputs.findIndex(input => input.classList.contains('sds-date-entry-input__field--selected'));
            if (field === 'month') {
                if (this._displayMonth === 'mm') {
                    if (currentIndex > 0) {
                        this.moveFocusToField(currentIndex - 1);
                    }
                    return;
                }
                if (this._displayMonth.length === 2 && this._displayMonth[0] === '1') {
                    this._displayMonth = '01';
                    this._awaitingSecondMonthDigit = true;
                    this._isUserInput = true;
                    this.updateHiddenInputValue();
                }
                else {
                    this._displayMonth = formatDateValue(null, 'month', this.locale);
                    this._awaitingSecondMonthDigit = false;
                    this._isUserInput = true;
                    const hiddenInput = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('input[type="hidden"]');
                    if (hiddenInput) {
                        hiddenInput.value = '';
                        if (this.value) {
                            this.dispatchChange(undefined);
                        }
                    }
                }
            }
            else if (field === 'day') {
                if (this._displayDay === 'dd') {
                    if (currentIndex > 0) {
                        this.moveFocusToField(currentIndex - 1);
                    }
                    return;
                }
                if (this._displayDay.length === 2 && this._displayDay[0] !== '0') {
                    const firstDigit = this._displayDay[0];
                    this._displayDay = '0' + firstDigit;
                    this._awaitingSecondDayDigit = true;
                    this._firstDayDigit = firstDigit;
                    this._isUserInput = true;
                    this.updateHiddenInputValue();
                }
                else {
                    this._displayDay = 'dd';
                    this._awaitingSecondDayDigit = false;
                    this._firstDayDigit = null;
                    this._isUserInput = true;
                    const hiddenInput = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('input[type="hidden"]');
                    if (hiddenInput) {
                        hiddenInput.value = '';
                        if (this.value) {
                            this.dispatchChange(undefined);
                        }
                    }
                }
            }
            else if (field === 'year') {
                if (this._displayYear === 'yyyy') {
                    if (currentIndex > 0) {
                        this.moveFocusToField(currentIndex - 1);
                    }
                    return;
                }
                if (this._displayYear.length > 0) {
                    this._displayYear = this._displayYear.slice(0, -1);
                    if (this._displayYear.length === 0) {
                        this._displayYear = 'yyyy';
                        this._isYearTyping = false;
                        this._isUserInput = true;
                        const hiddenInput = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('input[type="hidden"]');
                        if (hiddenInput) {
                            hiddenInput.value = '';
                            if (this.value) {
                                this.dispatchChange(undefined);
                            }
                        }
                    }
                    else {
                        this._isYearTyping = true;
                        this._isUserInput = true;
                        if (!isNaN(parseInt(this._displayYear))) {
                            this.validateDayForFebruary(parseInt(this._displayYear));
                            this.updateHiddenInputValue();
                        }
                        else {
                            this._displayYear = 'yyyy';
                            this._isYearTyping = false;
                            const hiddenInput = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('input[type="hidden"]');
                            if (hiddenInput) {
                                hiddenInput.value = '';
                                if (this.value) {
                                    this.dispatchChange(undefined);
                                }
                            }
                        }
                    }
                }
            }
        }
        resetTypingStates() {
            // Reset all typing and selection states
            this._isYearTyping = false;
            this._isMonthSelected = false;
            this._isDaySelected = false;
            this._isYearSelected = false;
            this._awaitingSecondMonthDigit = false;
            this._awaitingSecondDayDigit = false;
            this._firstDayDigit = null;
        }
        getCurrentMonth() {
            const currentDate = this._internalValue || keyToDate(this.currentDay);
            const { 1: month } = currentDate;
            return this._displayMonth === 'mm' ? month : parseInt(this._displayMonth);
        }
        getCurrentDay() {
            const currentDate = this._internalValue || keyToDate(this.currentDay);
            const { 2: day } = currentDate;
            return this._displayDay === 'dd' ? day : parseInt(this._displayDay);
        }
        getCurrentYear() {
            const currentDate = this._internalValue || keyToDate(this.currentDay);
            const { 0: year } = currentDate;
            if (this._displayYear === 'yyyy') {
                return year;
            }
            // Pad the display year to 4 digits for proper validation
            const displayYear = parseInt(this._displayYear);
            const paddedYear = displayYear.toString().padStart(4, '0');
            return parseInt(paddedYear);
        }
        handleFirstDayDigit(digit, daysInMonth) {
            var _a;
            const maxFirstDigit = Math.floor(daysInMonth / 10);
            this._displayDay = formatDateValue(parseInt(digit), 'day', this.locale);
            if (parseInt(digit) > maxFirstDigit) {
                // If digit is too high for any valid day in this month, set and move to next field
                this._awaitingSecondDayDigit = false;
                this._firstDayDigit = null;
                const inputs = Array.from(((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field')) || []);
                const currentIndex = inputs.findIndex(input => input.classList.contains('sds-date-entry-input__field--selected'));
                this.moveFocusToField(currentIndex + 1);
                this.updateHiddenInputValue();
            }
            else {
                // If digit could be part of a valid day, wait for second digit
                this._awaitingSecondDayDigit = true;
                this._firstDayDigit = digit;
                this.updateHiddenInputValue();
            }
        }
        handleKeyDown(event) {
            var _a;
            // Don't handle keyboard events when disabled
            if (this.disabled) {
                return;
            }
            const target = event.target;
            const selection = window.getSelection();
            // If there's a selection, only allow copy shortcut
            if (selection && selection.toString().length > 0) {
                // Check for copy shortcut (Cmd+C on Mac, Ctrl+C on Windows)
                if (event.key === 'c' && (event.ctrlKey || event.metaKey)) {
                    // Check if all fields have valid values
                    const hasValidMonth = this._displayMonth !== 'mm';
                    const hasValidDay = this._displayDay !== 'dd';
                    const hasValidYear = this._displayYear !== 'yyyy';
                    if (hasValidMonth && hasValidDay && hasValidYear) {
                        // Copy shortcut detected, allowing copy - all fields valid
                        return;
                    }
                    else {
                        // Copy shortcut detected, preventing copy - incomplete date
                        event.preventDefault();
                        return;
                    }
                }
                // Prevent all other keys when text is selected
                event.preventDefault();
                return;
            }
            // Handle tab navigation
            if (event.key === 'Tab') {
                return;
            }
            // Only handle keys when a field is selected
            if (!target.classList.contains('sds-date-entry-input__field--selected')) {
                event.preventDefault();
                return;
            }
            // Handle navigation keys first
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                event.preventDefault();
                this.handleArrowNavigation(event, target);
                return;
            }
            // Get the current field type based on locale order
            const fieldOrder = getFieldOrder(this.locale);
            const inputs = Array.from(((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field')) || []);
            const currentIndex = inputs.indexOf(target);
            const currentType = fieldOrder[currentIndex];
            // Handle delete/backspace
            if (event.key === 'Delete' || event.key === 'Backspace') {
                event.preventDefault();
                if (currentType === 'month') {
                    this.handleFieldDeletion('month');
                }
                else if (currentType === 'day') {
                    this.handleFieldDeletion('day');
                }
                else if (currentType === 'year') {
                    this.handleFieldDeletion('year');
                }
                return;
            }
            // Handle day input
            if (currentType === 'day') {
                event.preventDefault();
                if (event.key.length === 1 && /^\d$/.test(event.key)) {
                    const digit = event.key;
                    const currentYear = this.getCurrentYear();
                    const selectedMonth = this.getCurrentMonth();
                    const daysInMonth = this.getDaysInMonth(currentYear, selectedMonth);
                    // If we have a two-digit number and not awaiting second digit (navigated back to field)
                    if (this._displayDay !== 'dd' &&
                        this._displayDay.length === 2 &&
                        !this._awaitingSecondDayDigit) {
                        // Start fresh with the new digit
                        if (digit === '0') {
                            // Keep current value instead of clearing to dd
                            return;
                        }
                        this.handleFirstDayDigit(digit, daysInMonth);
                        return;
                    }
                    // If awaiting second digit
                    if (this._awaitingSecondDayDigit) {
                        const firstDigit = this._firstDayDigit || '0';
                        const newValue = firstDigit + digit;
                        const dayNum = parseInt(newValue);
                        // Check if the complete day is valid for this month
                        if (dayNum > 0 && dayNum <= daysInMonth) {
                            this._displayDay = newValue;
                            this._awaitingSecondDayDigit = false;
                            this._firstDayDigit = null;
                            // Move to next field since we've completed the day
                            this.moveFocusToField(currentIndex + 1);
                            this.updateHiddenInputValue();
                            return;
                        }
                        // If invalid, use the last digit and move to next field
                        this._displayDay = '0' + digit;
                        this._awaitingSecondDayDigit = false;
                        this._firstDayDigit = null;
                        this.moveFocusToField(currentIndex + 1);
                        this.updateHiddenInputValue();
                        return;
                    }
                    // Handle first digit when field is 'dd'
                    if (digit === '0') {
                        return;
                    }
                    this.handleFirstDayDigit(digit, daysInMonth);
                    return;
                }
                // Handle up/down for day navigation
                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    this.handleDayNavigation(event, this.getCurrentYear(), this.getCurrentDay());
                    return;
                }
            }
            if (currentType === 'month') {
                event.preventDefault();
                // Handle month input
                if (event.key.length === 1 && /^\d$/.test(event.key)) {
                    const digit = event.key;
                    // If awaiting second digit, process as second digit
                    if (this._awaitingSecondMonthDigit) {
                        const firstDigit = this._displayMonth[1];
                        // If first digit is 1 and second digit is 0,1,2
                        if (firstDigit === '1' && ['0', '1', '2'].includes(digit)) {
                            const newValue = '1' + digit;
                            this._displayMonth = newValue;
                            this._awaitingSecondMonthDigit = false;
                            // Validate and adjust day for new month
                            this.validateAndAdjustDayForMonth(parseInt(newValue));
                            // Move to next field
                            this.moveFocusToField(currentIndex + 1);
                            this.updateHiddenInputValue();
                            return;
                        }
                        // If first digit is 1 and second digit is 3-9
                        if (firstDigit === '1' && /[3-9]/.test(digit)) {
                            this._displayMonth = '0' + digit;
                            this._awaitingSecondMonthDigit = false;
                            // Move to next field
                            this.moveFocusToField(currentIndex + 1);
                            this.updateHiddenInputValue();
                            return;
                        }
                    }
                    // If month is not 'mm' and not awaiting second digit, treat as new entry
                    if (this._displayMonth !== 'mm' && !this._awaitingSecondMonthDigit) {
                        // If user presses 0, ignore and keep current value
                        if (digit === '0') {
                            return;
                        }
                    }
                    // Handle first digit input
                    if (digit === '0') {
                        return;
                    }
                    // If digit is 2-9, set to 02-09 and move to next field
                    if (parseInt(digit) > 1) {
                        const newValue = '0' + digit;
                        this._displayMonth = newValue;
                        this._awaitingSecondMonthDigit = false;
                        // Validate and adjust day for new month
                        this.validateAndAdjustDayForMonth(parseInt(newValue));
                        // Move to next field
                        this.moveFocusToField(currentIndex + 1);
                        this.updateHiddenInputValue();
                        return;
                    }
                    // If digit is 1, wait for second digit (can be 10,11,12)
                    this._displayMonth = '0' + digit;
                    this._awaitingSecondMonthDigit = true;
                    this.updateHiddenInputValue();
                    return;
                }
                // Handle up/down for month navigation
                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    this.handleMonthNavigation(event, this.getCurrentMonth());
                    return;
                }
                return;
            }
            // Handle year input
            if (currentType === 'year') {
                event.preventDefault();
                if (event.key.length === 1 && /^\d$/.test(event.key)) {
                    const digit = event.key;
                    // If year is 'yyyy' and input is '0', ignore it
                    if (this._displayYear === 'yyyy' && digit === '0') {
                        return;
                    }
                    // If we're not typing and have an existing year, start fresh
                    if (!this._isYearTyping && this._displayYear !== 'yyyy') {
                        // Don't allow '0' as first digit
                        if (digit === '0') {
                            return;
                        }
                        this._displayYear = digit;
                        this._isYearTyping = true;
                        // Validate day for February when year changes
                        this.validateDayForFebruary(parseInt(digit));
                        this.updateHiddenInputValue();
                        return;
                    }
                    // If we already have 4 digits, start fresh
                    if (this._displayYear.length >= 4) {
                        // Don't allow '0' as first digit
                        if (digit === '0') {
                            return;
                        }
                        this._displayYear = digit;
                        this._isYearTyping = true;
                        // Validate day for February when year changes
                        this.validateDayForFebruary(parseInt(digit));
                        this.updateHiddenInputValue();
                        return;
                    }
                    // Add the new digit to existing year
                    this._displayYear = this._displayYear + digit;
                    this._isYearTyping = true;
                    // Validate day for February after each digit change
                    this.validateDayForFebruary(parseInt(this._displayYear));
                    this.updateHiddenInputValue();
                    return;
                }
                // Handle up/down for year navigation
                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    this.handleYearNavigation(event, this.getCurrentYear());
                    return;
                }
            }
            event.preventDefault();
        }
        dispatchInputEvent() {
            // Get current date value
            const hasMonthDigits = this._displayMonth !== 'mm';
            const hasDayDigits = this._displayDay !== 'dd';
            const hasYearDigits = this._displayYear !== 'yyyy';
            // Create a partial date object with current field values
            const partialDate = {
                month: hasMonthDigits ? parseInt(this._displayMonth) : undefined,
                day: hasDayDigits ? parseInt(this._displayDay) : undefined,
                year: hasYearDigits ? parseInt(this._displayYear) : undefined,
            };
            let selectedDate;
            if (hasMonthDigits && hasDayDigits && hasYearDigits) {
                const month = parseInt(this._displayMonth);
                const day = parseInt(this._displayDay);
                const year = parseInt(this._displayYear);
                selectedDate = dateToKey(year, month, day);
            }
            // Dispatch custom input event
            this.dispatchEvent(new CustomEvent(SdsDateEntryInput.INPUT_EVENT, {
                bubbles: true,
                composed: true,
                detail: {
                    selectedDate: selectedDate,
                    partialDate: partialDate,
                },
            }));
            // Dispatch native input event
            this.dispatchEvent(new CustomEvent('input', {
                bubbles: true,
                composed: true,
                detail: {
                    selectedDate: selectedDate,
                    partialDate: partialDate,
                },
            }));
        }
        handleDayNavigation(event, year, day) {
            event.preventDefault(); // Prevent default scrolling
            // Get the current displayed values
            const currentYear = this._displayYear === 'yyyy' ? year : parseInt(this._displayYear);
            const currentMonth = this.getCurrentMonth();
            const daysInMonth = this.getDaysInMonth(currentYear, currentMonth);
            let newDay;
            // If we're showing placeholder or if the value is invalid, start with current day
            if (this._displayDay === 'dd' || !this._displayDay || isNaN(parseInt(this._displayDay))) {
                newDay = day;
                // Ensure the current day is valid for the selected month
                if (newDay > daysInMonth) {
                    newDay = daysInMonth;
                }
            }
            else {
                const displayDay = parseInt(this._displayDay);
                if (event.key === 'ArrowUp') {
                    newDay = displayDay === daysInMonth ? 1 : displayDay + 1;
                }
                else if (event.key === 'ArrowDown') {
                    newDay = displayDay === 1 ? daysInMonth : displayDay - 1;
                }
                else {
                    newDay = displayDay;
                }
            }
            // Ensure the new day is valid for the month
            newDay = Math.min(newDay, daysInMonth);
            newDay = Math.max(newDay, 1);
            // Update only the day display value
            this._displayDay = formatDateValue(newDay, 'day', this.locale);
            this._awaitingSecondDayDigit = false;
            this._firstDayDigit = null;
            // Update the hidden input value and dispatch events
            this.updateHiddenInputValue();
        }
        handleMonthNavigation(event, currentMonth) {
            event.preventDefault(); // Prevent default scrolling
            let newMonth;
            // Always start with current month if we're showing placeholder or if the value is invalid
            if (this._displayMonth === 'mm' ||
                !this._displayMonth ||
                isNaN(parseInt(this._displayMonth))) {
                newMonth = currentMonth;
            }
            else {
                const currentDisplayMonth = parseInt(this._displayMonth);
                if (event.key === 'ArrowUp') {
                    newMonth = currentDisplayMonth === 12 ? 1 : currentDisplayMonth + 1;
                }
                else if (event.key === 'ArrowDown') {
                    newMonth = currentDisplayMonth === 1 ? 12 : currentDisplayMonth - 1;
                }
                else {
                    newMonth = currentDisplayMonth;
                }
            }
            // Update only the month display value
            this._displayMonth = formatDateValue(newMonth, 'month', this.locale);
            this._awaitingSecondMonthDigit = false;
            // Validate and adjust day for new month
            this.validateAndAdjustDayForMonth(newMonth);
            // Update the hidden input value and dispatch events
            this.updateHiddenInputValue();
        }
        handleYearNavigation(event, currentYear) {
            event.preventDefault(); // Prevent default scrolling
            let newYear;
            // Always start with current year if we're showing placeholder or if the value is invalid
            if (this._displayYear === 'yyyy' ||
                !this._displayYear ||
                isNaN(parseInt(this._displayYear))) {
                newYear = currentYear;
            }
            else {
                const currentDisplayYear = parseInt(this._displayYear);
                if (event.key === 'ArrowUp') {
                    newYear = currentDisplayYear + 1;
                }
                else if (event.key === 'ArrowDown') {
                    newYear = currentDisplayYear - 1;
                }
                else {
                    newYear = currentDisplayYear;
                }
            }
            // Update only the year display value
            this._displayYear = formatDateValue(newYear, 'year', this.locale);
            this._isYearTyping = false;
            // Validate day for February when year changes
            this.validateDayForFebruary(newYear);
            // Update the hidden input value and dispatch events
            this.updateHiddenInputValue();
        }
        handleArrowNavigation(event, target) {
            var _a;
            const inputs = Array.from(((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field')) || []);
            const currentIndex = inputs.indexOf(target);
            const isRTL = document.dir === 'rtl';
            let nextIndex;
            if (event.key === 'ArrowLeft') {
                // For LTR: move left (previous field)
                // For RTL: move right (next field)
                nextIndex = isRTL ? currentIndex + 1 : currentIndex - 1;
                // Don't move if we're at the start (LTR) or end (RTL)
                if ((isRTL && currentIndex === inputs.length - 1) || (!isRTL && currentIndex === 0)) {
                    return;
                }
            }
            else {
                // For LTR: move right (next field)
                // For RTL: move left (previous field)
                nextIndex = isRTL ? currentIndex - 1 : currentIndex + 1;
                // Don't move if we're at the end (LTR) or start (RTL)
                if ((isRTL && currentIndex === 0) || (!isRTL && currentIndex === inputs.length - 1)) {
                    return;
                }
            }
            this.resetTypingStates();
            this.moveFocusToField(nextIndex);
        }
        getDaysInMonth(year, month) {
            return new Date(year, month, 0).getDate();
        }
        validateAndAdjustDayForMonth(newMonth) {
            // Only proceed if we have a valid day value
            if (this._displayDay === 'dd' || !this._displayDay) {
                return;
            }
            const currentDay = parseInt(this._displayDay);
            let currentYear;
            if (this._displayYear === 'yyyy') {
                currentYear = new Date().getFullYear();
            }
            else {
                // Pad the display year to 4 digits for proper validation
                const displayYear = parseInt(this._displayYear);
                const paddedYear = displayYear.toString().padStart(4, '0');
                currentYear = parseInt(paddedYear);
            }
            const daysInNewMonth = this.getDaysInMonth(currentYear, newMonth);
            // If current day is valid for new month, no adjustment needed
            if (currentDay <= daysInNewMonth) {
                return;
            }
            // Adjust day to last day of new month
            this._displayDay = formatDateValue(daysInNewMonth, 'day', this.locale);
        }
        validateDayForFebruary(year) {
            if (this._displayMonth !== 'mm' && this._displayDay !== 'dd') {
                const month = parseInt(this._displayMonth);
                if (month === 2) {
                    const day = parseInt(this._displayDay);
                    // Pad year to 4 digits for proper validation
                    const paddedYear = year.toString().padStart(4, '0');
                    const paddedYearNum = parseInt(paddedYear);
                    const daysInMonth = this.getDaysInMonth(paddedYearNum, month);
                    if (day > daysInMonth) {
                        this._displayDay = formatDateValue(daysInMonth, 'day', this.locale);
                    }
                }
            }
        }
        updateHiddenInputValue() {
            var _a;
            const hiddenInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('input[type="hidden"]');
            if (!hiddenInput)
                return;
            // Check if all fields have digits (not placeholder values)
            const hasMonthDigits = this._displayMonth !== 'mm';
            const hasDayDigits = this._displayDay !== 'dd';
            const hasYearDigits = this._displayYear !== 'yyyy';
            // Always dispatch input event when any field changes
            this.dispatchInputEvent();
            // If any field is incomplete, clear the value
            if (!hasMonthDigits || !hasDayDigits || !hasYearDigits) {
                hiddenInput.value = '';
                // Only dispatch change if we previously had a valid date and we're not clearing
                if (this.value && !this._isClearing) {
                    this.dispatchChange(undefined);
                }
                return;
            }
            // All fields have digits, validate the date
            const month = parseInt(this._displayMonth);
            const day = parseInt(this._displayDay);
            const year = parseInt(this._displayYear);
            // Pad year to 4 digits for proper date validation
            const paddedYear = year.toString().padStart(4, '0');
            const paddedYearNum = parseInt(paddedYear);
            // Validate the date using padded year
            const daysInMonth = this.getDaysInMonth(paddedYearNum, month);
            if (day <= daysInMonth) {
                const date = [paddedYearNum, month, day];
                hiddenInput.value = dateToSpecifiedFormat(date, 'yyyy-MM-dd');
                // Dispatch change event for valid date
                this.dispatchChange(date);
            }
            else {
                hiddenInput.value = '';
                // Only dispatch change if we previously had a valid date and we're not clearing
                if (this.value && !this._isClearing) {
                    this.dispatchChange(undefined);
                }
            }
        }
        updated(_changedProperties) {
            // Update display when value changes
            if (_changedProperties.has('_internalValue')) {
                // If this is a user input change, don't reset the display values
                if (this._isUserInput) {
                    this._isUserInput = false;
                    return;
                }
                if (this._internalValue) {
                    const [year, month, day] = this._internalValue;
                    this._displayMonth = formatDateValue(month, 'month', this.locale);
                    this._displayDay = formatDateValue(day, 'day', this.locale);
                    this._displayYear = formatDateValue(year, 'year', this.locale);
                }
                else {
                    // Reset display values when date is null/undefined
                    this._displayMonth = formatDateValue(null, 'month', this.locale);
                    this._displayDay = formatDateValue(null, 'day', this.locale);
                    this._displayYear = formatDateValue(null, 'year', this.locale);
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('click', this.handleDocumentClick);
        }
        disconnectedCallback() {
            document.removeEventListener('click', this.handleDocumentClick);
            super.disconnectedCallback();
        }
        dispatchChange(date) {
            const selectedDate = date ? dateToKey(...date) : undefined;
            this.dispatchEvent(new CustomEvent(SdsDateEntryInput.CHANGE_EVENT, {
                detail: { selectedDate },
            }));
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        focus() {
            var _a, _b;
            if (this.disabled) {
                return;
            }
            const inputs = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
            if (!inputs || inputs.length === 0)
                return;
            // Focus the first field by default
            this.moveFocusToField(0);
            // Dispatch focus event
            const container = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.sds-date-entry-input');
            this.dispatchEvent(new CustomEvent('focus', {
                bubbles: true,
                composed: true,
                detail: {
                    target: container,
                    relatedTarget: null,
                },
            }));
        }
        blur() {
            var _a, _b;
            if (this.disabled) {
                return;
            }
            // Remove selected class from all inputs
            const inputs = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.sds-date-entry-input__field');
            inputs === null || inputs === void 0 ? void 0 : inputs.forEach(input => {
                input.classList.remove('sds-date-entry-input__field--selected');
                input.blur();
            });
            // Reset typing states and field focus state
            this.resetTypingStates();
            this._isFieldFocused = false;
            // Dispatch blur event
            const container = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.sds-date-entry-input');
            this.dispatchEvent(new CustomEvent('blur', {
                bubbles: true,
                composed: true,
                detail: {
                    target: container,
                    relatedTarget: null,
                },
            }));
        }
        click() {
            if (this.disabled) {
                return;
            }
            // Create a synthetic click event
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                composed: true,
            });
            // Call handleInputContainerClick with the synthetic event
            this.handleInputContainerClick(clickEvent);
        }
        /**
         * Sets the internal value directly without going through string parsing.
         * This is used by the parent component to avoid parsing issues.
         */
        setInternalValue(date) {
            this._internalValue = date;
            this.requestUpdate();
        }
    };
    _SdsDateEntryInput_hint_accessor_storage = new WeakMap();
    _SdsDateEntryInput_disabled_accessor_storage = new WeakMap();
    _SdsDateEntryInput_invalid_accessor_storage = new WeakMap();
    _SdsDateEntryInput_errorMessage_accessor_storage = new WeakMap();
    _SdsDateEntryInput_locale_accessor_storage = new WeakMap();
    _SdsDateEntryInput__internalValue_accessor_storage = new WeakMap();
    _SdsDateEntryInput_currentDay_accessor_storage = new WeakMap();
    _SdsDateEntryInput_hasClear_accessor_storage = new WeakMap();
    _SdsDateEntryInput__displayMonth_accessor_storage = new WeakMap();
    _SdsDateEntryInput__displayDay_accessor_storage = new WeakMap();
    _SdsDateEntryInput__displayYear_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isMonthSelected_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isDaySelected_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isYearSelected_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isYearTyping_accessor_storage = new WeakMap();
    _SdsDateEntryInput__buttonFocused_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isFieldFocused_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isUserInput_accessor_storage = new WeakMap();
    _SdsDateEntryInput__isClearing_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDateEntryInput");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _locale_decorators = [property({ type: String })];
        __internalValue_decorators = [property({
                converter: {
                    fromAttribute: (value) => {
                        if (!value)
                            return undefined;
                        return parseAndValidateDate(value);
                    },
                    toAttribute: (value) => {
                        if (!value)
                            return '';
                        return dateToKey(...value);
                    },
                },
                attribute: 'value',
            })];
        _currentDay_decorators = [property({ attribute: 'current-date' })];
        _hasClear_decorators = [property({ attribute: 'has-clear', type: Boolean, reflect: true })];
        __displayMonth_decorators = [state()];
        __displayDay_decorators = [state()];
        __displayYear_decorators = [state()];
        __isMonthSelected_decorators = [state()];
        __isDaySelected_decorators = [state()];
        __isYearSelected_decorators = [state()];
        __isYearTyping_decorators = [state()];
        __buttonFocused_decorators = [state()];
        __isFieldFocused_decorators = [state()];
        __isUserInput_decorators = [state()];
        __isClearing_decorators = [state()];
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, __internalValue_decorators, { kind: "accessor", name: "_internalValue", static: false, private: false, access: { has: obj => "_internalValue" in obj, get: obj => obj._internalValue, set: (obj, value) => { obj._internalValue = value; } }, metadata: _metadata }, __internalValue_initializers, __internalValue_extraInitializers);
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, _hasClear_decorators, { kind: "accessor", name: "hasClear", static: false, private: false, access: { has: obj => "hasClear" in obj, get: obj => obj.hasClear, set: (obj, value) => { obj.hasClear = value; } }, metadata: _metadata }, _hasClear_initializers, _hasClear_extraInitializers);
        __esDecorate(_classThis, null, __displayMonth_decorators, { kind: "accessor", name: "_displayMonth", static: false, private: false, access: { has: obj => "_displayMonth" in obj, get: obj => obj._displayMonth, set: (obj, value) => { obj._displayMonth = value; } }, metadata: _metadata }, __displayMonth_initializers, __displayMonth_extraInitializers);
        __esDecorate(_classThis, null, __displayDay_decorators, { kind: "accessor", name: "_displayDay", static: false, private: false, access: { has: obj => "_displayDay" in obj, get: obj => obj._displayDay, set: (obj, value) => { obj._displayDay = value; } }, metadata: _metadata }, __displayDay_initializers, __displayDay_extraInitializers);
        __esDecorate(_classThis, null, __displayYear_decorators, { kind: "accessor", name: "_displayYear", static: false, private: false, access: { has: obj => "_displayYear" in obj, get: obj => obj._displayYear, set: (obj, value) => { obj._displayYear = value; } }, metadata: _metadata }, __displayYear_initializers, __displayYear_extraInitializers);
        __esDecorate(_classThis, null, __isMonthSelected_decorators, { kind: "accessor", name: "_isMonthSelected", static: false, private: false, access: { has: obj => "_isMonthSelected" in obj, get: obj => obj._isMonthSelected, set: (obj, value) => { obj._isMonthSelected = value; } }, metadata: _metadata }, __isMonthSelected_initializers, __isMonthSelected_extraInitializers);
        __esDecorate(_classThis, null, __isDaySelected_decorators, { kind: "accessor", name: "_isDaySelected", static: false, private: false, access: { has: obj => "_isDaySelected" in obj, get: obj => obj._isDaySelected, set: (obj, value) => { obj._isDaySelected = value; } }, metadata: _metadata }, __isDaySelected_initializers, __isDaySelected_extraInitializers);
        __esDecorate(_classThis, null, __isYearSelected_decorators, { kind: "accessor", name: "_isYearSelected", static: false, private: false, access: { has: obj => "_isYearSelected" in obj, get: obj => obj._isYearSelected, set: (obj, value) => { obj._isYearSelected = value; } }, metadata: _metadata }, __isYearSelected_initializers, __isYearSelected_extraInitializers);
        __esDecorate(_classThis, null, __isYearTyping_decorators, { kind: "accessor", name: "_isYearTyping", static: false, private: false, access: { has: obj => "_isYearTyping" in obj, get: obj => obj._isYearTyping, set: (obj, value) => { obj._isYearTyping = value; } }, metadata: _metadata }, __isYearTyping_initializers, __isYearTyping_extraInitializers);
        __esDecorate(_classThis, null, __buttonFocused_decorators, { kind: "accessor", name: "_buttonFocused", static: false, private: false, access: { has: obj => "_buttonFocused" in obj, get: obj => obj._buttonFocused, set: (obj, value) => { obj._buttonFocused = value; } }, metadata: _metadata }, __buttonFocused_initializers, __buttonFocused_extraInitializers);
        __esDecorate(_classThis, null, __isFieldFocused_decorators, { kind: "accessor", name: "_isFieldFocused", static: false, private: false, access: { has: obj => "_isFieldFocused" in obj, get: obj => obj._isFieldFocused, set: (obj, value) => { obj._isFieldFocused = value; } }, metadata: _metadata }, __isFieldFocused_initializers, __isFieldFocused_extraInitializers);
        __esDecorate(_classThis, null, __isUserInput_decorators, { kind: "accessor", name: "_isUserInput", static: false, private: false, access: { has: obj => "_isUserInput" in obj, get: obj => obj._isUserInput, set: (obj, value) => { obj._isUserInput = value; } }, metadata: _metadata }, __isUserInput_initializers, __isUserInput_extraInitializers);
        __esDecorate(_classThis, null, __isClearing_decorators, { kind: "accessor", name: "_isClearing", static: false, private: false, access: { has: obj => "_isClearing" in obj, get: obj => obj._isClearing, set: (obj, value) => { obj._isClearing = value; } }, metadata: _metadata }, __isClearing_initializers, __isClearing_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDateEntryInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'sds.date-picker.changed';
    _classThis.DATE_CLEARED = 'sds.date.cleared';
    _classThis.INPUT_EVENT = 'sds.date-picker.input';
    _classThis.CALENDAR_BUTTON_CLICKED = 'sds.date-entry-input.calendar-clicked';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDateEntryInput = _classThis;
})();
export { SdsDateEntryInput };
